
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Icon from 'components/Icon'
import {CSSTransitionGroup} from 'react-transition-group'

export default class TopbarDropdown extends React.Component {
  static propTypes = {
    fullHeight: PropTypes.bool,
    className: PropTypes.string,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    iconOnTheRight: PropTypes.string,
    iconOnTheLeft: PropTypes.string,
    forceClose: PropTypes.bool
  }

  constructor(props) {
    super(props)
    this.state = {
      opened: false
    }
  }

  componentWillUpdate(props, state) {
    if (state.opened) {
      document.addEventListener('click', this.onHideDropdown)
    } else {
      document.removeEventListener('click', this.onHideDropdown)
    }
  }

  componentDidUpdate() {
    if (this.props.forceClose) {
      this.hideDropdown()
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.onHideDropdown)
  }

  render() {
    const {className, title, iconOnTheRight, iconOnTheLeft} = this.props
    const {opened} = this.state
    const dropdownClassName = classnames('topbar-dropdown', className, {'is-opened': opened})

    return (
      <div
        className={dropdownClassName}
        onClick={this.onClick}
      >
        <div className='topbar-dropdown_title'>
          {iconOnTheLeft ? <Icon name={iconOnTheLeft} size='12px' className='topbar-dropdown_title-icon' /> : null}
          <div className='topbar-dropdown_title-sign'>{title}</div>
          {iconOnTheRight ? <Icon name={iconOnTheRight} size='12px' className='topbar-dropdown_title-icon' /> : null}
        </div>
        <CSSTransitionGroup
          transitionName='is-transition'
          transitionEnterTimeout={200}
          transitionLeaveTimeout={200}
        >
          {this.renderChildren()}
        </CSSTransitionGroup>
      </div>
    )
  }

  renderChildren() {
    const {fullHeight} = this.props
    const {opened} = this.state

    if (opened) {
      const classNames = classnames('topbar-dropdown_list', {
        'is-full_height': fullHeight
      })
      return (
        <div className={classNames} ref={el => {
          const {selectorRef} = this.state

          if (el && !selectorRef) {
            this.setState({
              selectorRef: el
            })
          }
        }}>
          {this.props.children}
        </div>
      )
    } else {
      return null
    }
  }

  onClick = evt => {
    const {selectorRef} = this.state

    if (selectorRef && selectorRef.contains(evt.target)) return false

    evt.stopPropagation()
    evt.preventDefault()

    if (this.state.opened) {
      this.hideDropdown()
    } else {
      this.setState({
        opened: true
      })
    }
  }

  onHideDropdown = evt => {
    const {selectorRef} = this.state

    if (selectorRef && selectorRef.contains(evt.target)) return false

    this.hideDropdown()
  }

  hideDropdown() {
    this.setState({
      opened: false,
      selectorRef: null
    })
  }
}

export class TopbarDropdownItem extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    className: PropTypes.string
  }

  render() {
    const {
      onClick,
      className
    } = this.props

    const classNames = classnames('topbar-dropdown_item', className)

    return (
      <div
        className={classNames}
        onClick={onClick}
      >
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Topbar/Dropdown/index.js